import { NotificationType } from "@/Modules/App/Models/Domain/NotificationType";

import { getStates } from "@/Services/TherapyApi/Clients";
import InfoFilterTransformer from "@/Modules/Transformers/Patients/InfoFilter";

import usePatientsStore from "../Store";
import useAppStore from "@/Modules/App/Store";

async function fetchStatesAH(): Promise<boolean> {
  const patientsStore = usePatientsStore();
  const appStore = useAppStore();

  patientsStore.isLoading = true;

  try {
    const states = await getStates();

    patientsStore.states = states.map(InfoFilterTransformer.toDomain);

    return true;
  } catch (error: unknown) {
    appStore.showSnackbar({
      type: NotificationType.ERROR,
      message: "there_was_an_error_connecting_to_the_server_please_try_again_later",
    });

    return false;
  } finally {
    patientsStore.isLoading = false;
  }
}

export default fetchStatesAH;
